<div class="interactive-item" (click)="onItemClick()">
  <div class="interactive-item__content">
    <div class="interactive-item__prefix"></div>
    @if (itemIcon && !isSvgIcon) {
      <mat-icon class="interactive-item__icon" aria-hidden="true">{{ itemIcon }}</mat-icon>
    }
    @if (itemIcon && isSvgIcon) {
      <mat-icon class="interactive-item__icon" [svgIcon]="itemIcon" aria-hidden="true" />
    }

    <span #textElement class="interactive-item__text" [matTooltip]="itemText" matTooltipPosition="above" matTooltipShowDelay="2000" matTooltipHideDelay="300">
      {{ itemText }}
    </span>

    @if (badge) {
      <span class="bg-[#f44336] text-white text-[11px] font-semibold h-[18px] min-w-[18px] px-1.5 flex items-center justify-center rounded-full ml-2">
        {{ badge }}
      </span>
    }
  </div>

  @if (buttons?.length) {
    <div class="interactive-item__actions">
      <button mat-icon-button (click)="onOptionsClick($event, optionsButton)" #optionsButton class="interactive-item__button" aria-label="More options" [disabled]="disabled">
        <mat-icon>more_horiz</mat-icon>
      </button>
    </div>
  }
</div>
